export const ABS = 129;
export const BLIND_SPOT_MONITOR = 52;
export const COLLISION_WARNING_SYSTEM = 67;
export const ESP = 134;
export const IMMOBILIZER = 124;
export const TRACTION_CONTROL = 117;
export const FOUR_WHEEL_DRIVE = 137;
export const BRAKE_ASSIST = 53;
export const LANE_DEPARTURE_WARNING_SYSTEM = 88;
export const LANE_CHANGE_ASSIST = 89;
export const CRUISE_CONTROL = 125;
export const CENTRAL_LOCKING = 59;
export const HAS_EMERGENCY_CALL_SYSTEM = 'hasEmergencyCallSystem';
export const HAS_SELF_PARKING_SYSTEM = 'hasSelfParkingSystem';
export const HAS_CRUISE_CONTROL = 'hasCruiseControl';
